(() => {
  if (customElements.get('store-location-detail')) return;

  function waitForGoogleMaps() {
    return new Promise((resolve) => {
      const isReady = () => typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.Map === 'function';

      if (isReady()) {
        resolve();
        return;
      }

      const check = () => {
        if (isReady()) {
          resolve();
          return;
        }
        requestAnimationFrame(check);
      };

      check();
    });
  }

  const MAP_STYLES = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#93b8db' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] }
  ];

  const PIN_SVG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 100">
      <path fill="#ffffff" d="M49.853,23.519c-2.15.493-3.383,1.332-4.276,2.136,2.025.493,4.459.941,6.164.455,1.178-.335,2-.874,2.197-1.442.079-.227.051-.437-.082-.622-.475-.66-2.346-.906-4.003-.527Z"/>
      <path fill="#ffffff" stroke="#ffffff" stroke-width="1.5" d="M23.811,30.719c.556,1.339,1.77,2.52,3.266,3.184.248-.324.672-.844,1.208-1.381.169-.168.352-.34.54-.518.857-.804,1.828-1.716,1.949-2.896.053-.515-.086-.984-.389-1.321-.27-.299-.649-.47-1.041-.47-1.59.037-1.956,1.573-1.97,1.639-.05.221-.243.379-.47.385-.238-.006-.43-.152-.488-.363-.016-.058-.413-1.435-2.052-1.681-.173-.026-.351-.04-.53-.041-.481,1.144-.489,2.338-.022,3.463Z"/>
      <path fill="#000000" stroke="#ffffff" stroke-width="1.5" d="M67.946,28.889c-1.981-14.398-13.167-25.895-27.521-28.233-2.597-.423-5.275-.506-7.96-.373-3.088.153-6.031.953-8.912,2.001C4.387,9.252-3.791,32.22,5.729,48.954l2.349,4.129,17.927,31.125,9.034,15.584,7.118-12.212,14.183-24.67,6.386-11.068c.784-1.359,1.47-2.597,2.163-3.995,1.688-3.401,2.854-6.998,3.158-10.819.218-2.734.266-5.468-.102-8.138ZM54.919,25.187c-.331.912-1.32,1.646-2.785,2.068-2.083.6-4.603.523-7.925-.241-1.751,1.867-3.663,4.404-5.841,7.754-.293.45-.595.899-.903,1.34.808-.036,1.51-.196,2.182-.496.244-.524.578-.939,1.02-1.268.994-.738,1.444-.503,1.625-.298.268.305.156.797-.286,1.252-.696.719-1.982,1.231-2.037,1.253l-.057.023c-.08.034-.164.067-.249.099l-.482.191.013-.036c-.742.216-1.53.302-2.438.27-4.546,6.176-9.303,9.306-14.139,9.306l-.181-.003c-1.423-.031-2.841-.42-3.891-1.066-1.409-.868-2.153-2.15-2.153-3.708,0-1.224.786-2.316,1.516-2.938l-.004-.007.295-.224c.078-.055.151-.103.224-.147,1.468-.936,2.56-.968,3.519-.864.801.087,1.305.312,1.497.67.112.209.113.453.002.669-.295.571-.948.369-1.424.221-.157-.049-.319-.099-.483-.137-.719-.166-1.663-.286-2.575.26l-.13.087c-.709.46-1.459,1.46-1.459,2.411,0,1.798,1.605,3.753,5.128,3.798l.116-.002c4.669,0,8.142-3.406,11.877-8.55-1.172-.134-2.088-.158-2.881.306-.11.065-.247.082-.375.048s-.238-.116-.302-.226c-.066-.112-.085-.245-.052-.373.033-.128.115-.236.229-.303,1.229-.718,2.577-.55,4.003-.373l.032.004c.448-.635.916-1.315,1.429-2.075,1.816-2.685,3.475-4.797,5.074-6.458.298-.309.574-.587.836-.843-1.122-.304-2.257-.647-3.357-.979l-.02-.006c-4.392-1.327-8.54-2.581-11.67-1.511l-.376.128v-.004c-1.167.459-2.076,1.162-2.71,2.094.053.006.105.013.157.021,1.222.183,1.953.873,2.347,1.409.392-.607,1.146-1.368,2.474-1.399h0c.68,0,1.328.29,1.785.795.493.546.72,1.286.638,2.082-.158,1.546-1.272,2.592-2.255,3.514-.191.179-.361.339-.518.496-.765.766-1.277,1.488-1.333,1.568-.126.185-.372.261-.583.18-1.905-.725-3.463-2.172-4.168-3.869-.495-1.192-.554-2.456-.175-3.679-.655.201-1.259.583-1.764,1.119-.157.167-.305.352-.437.548-.109.216-.565,1.253-.203,2.964l.005.025c.075.351.199.938-.353,1.14-.169.063-.361.048-.527-.041-.238-.128-.418-.404-.507-.776-.059-.248-.092-.508-.1-.794-.076-1.348.436-2.714,1.403-3.742.805-.856,1.85-1.404,2.952-1.552,1.007-1.866,2.834-3.082,5.291-3.518,4.04-.778,8.975.616,13.328,1.847l.07.02c.723.204,1.407.398,2.088.582,1.733-1.417,3.418-2.231,5.613-2.715,2.256-.497,4.412-.09,5.126.967h0c.346.513.421,1.115.21,1.695Z"/>
    </svg>
  `);

  class StoreLocationDetail extends HTMLElement {
    constructor() {
      super();
      this.map = null;
      this.onZoomIn = this.onZoomIn.bind(this);
      this.onZoomOut = this.onZoomOut.bind(this);
    }

    connectedCallback() {
      this.mapContainer = this.querySelector('[data-map]');
      this.zoomInBtn = this.querySelector('[data-zoom-in]');
      this.zoomOutBtn = this.querySelector('[data-zoom-out]');
      this.setEventListeners();

      waitForGoogleMaps().then(() => {
        if (!this.isConnected) return;
        this.initMap();
      });
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    setEventListeners() {
      this.zoomInBtn?.addEventListener('click', this.onZoomIn);
      this.zoomOutBtn?.addEventListener('click', this.onZoomOut);
    }

    removeEventListeners() {
      this.zoomInBtn?.removeEventListener('click', this.onZoomIn);
      this.zoomOutBtn?.removeEventListener('click', this.onZoomOut);
    }

    initMap() {
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.warn('Store Location Detail: Google Maps API not loaded.');
        return;
      }

      const lat = parseFloat(this.dataset.lat);
      const lng = parseFloat(this.dataset.lng);
      const name = this.dataset.name || '';

      if (isNaN(lat) || isNaN(lng) || (lat === 0 && lng === 0)) return;

      const center = { lat, lng };

      this.map = new google.maps.Map(this.mapContainer, {
        zoom: 15,
        center: center,
        disableDefaultUI: true,
        gestureHandling: 'cooperative',
        styles: MAP_STYLES
      });

      new google.maps.Marker({
        position: center,
        map: this.map,
        title: name,
        icon: {
          url: PIN_SVG,
          scaledSize: new google.maps.Size(28, 40),
          anchor: new google.maps.Point(14, 40)
        }
      });
    }

    onZoomIn() {
      if (!this.map) return;
      this.map.setZoom(this.map.getZoom() + 1);
    }

    onZoomOut() {
      if (!this.map) return;
      this.map.setZoom(this.map.getZoom() - 1);
    }
  }

  customElements.define('store-location-detail', StoreLocationDetail);
})();
